<div mat-dialog-title>
  <h2>Import</h2>
  <eiq-button
    [title]="'Close import dialog'"
    [color]="'light'"
    [style]="'icon'"
    [icon]="faClose"
    testId="import-translations-dialog-close"
    class="mat-dialog-title__close"
    (clicked)="onCancel()"
  ></eiq-button>
</div>
<div mat-dialog-content class="import-translations-dialog__content">
  @if (uploadedFile$(); as file) {
    <eiq-card [style]="'light'">
      <div slot="content" class="import-translations-dialog__uploaded-file">
        <fa-icon [icon]="faFileSpreadsheet"></fa-icon>

        <div class="import-translations-dialog__uploaded-file-name">
          <span class="text__sm fw__600">{{ file.name }}</span>
          <span class="text__sm">{{ fileSize$() }}</span>
        </div>

        <eiq-icon-button
          [icon]="faTrash"
          [style]="'basic'"
          [color]="'light'"
          testId="import-translations-dialog-remove-file"
          (clicked)="onRemoveFile()"
        ></eiq-icon-button>
      </div>
    </eiq-card>
  } @else {
    <eiq-file-uploader
      [acceptedTypes]="acceptedTypes"
      [acceptedTypesText]="acceptedTypesText"
      [maxSize]="maxFileSize"
      testId="import-translations-dialog"
      [uploading]="uploading$()"
      (uploaded)="onUpload($event)"
    ></eiq-file-uploader>
  }

  @if (!importResult$()) {
    <eiq-card [style]="'medium'">
      <div slot="content" class="import-translations-dialog__overwrite-content">
        <mat-checkbox color="accent" data-testid="import-translations-dialog-overwrite-checkbox" [(ngModel)]="overwriteExisting$"></mat-checkbox>

        <div class="import-translations-dialog__overwrite-description">
          <span class="text__sm fw__600">Overwrite existing translations</span>
          <span class="text__sm">If unchecked, only empty or missing translations will be updated. Existing values will be preserved.</span>
        </div>
      </div>
    </eiq-card>

    <eiq-info-banner class="import-translations-dialog__format-description" [icon]="faCircleInfo">
      <span class="text__sm" slot="title">Ensure your file has a ID, “Ignored”, “{{ defaultLanguageCode$() }}” and “{{ data.translation.code }}” columns</span>
    </eiq-info-banner>
  } @else if (importResult$()?.issues.length) {
    <div class="import-translations-dialog__issues">
      <div class="import-translations-dialog__issues-header">
        <fa-icon [icon]="faCircleInfo"></fa-icon>
        <div class="import-translations-dialog__issues-header-text">
          <span class="fw__600">Issues found in your tranlsation file</span>
          <span class="text__sm">{{ issuesMessage$() }}</span>
        </div>
      </div>

      <div class="import-translations-dialog__issues-content">
        @for (issue of importResult$().issues; track issue) {
          <eiq-info-banner [icon]="faCircleInfo" [color]="issue.type === importIssueType.Warning ? 'alert' : 'warn'">
            <div slot="title" class="import-translations-dialog__issues-row">
              @if (issue.row) {
                <span class="text__sm fw__600 row-number">Row {{ issue.row }}</span>
              }
              <span class="text__sm">{{ issue.message }}</span>
            </div>
          </eiq-info-banner>
        }
      </div>
    </div>
  }
</div>
<div mat-dialog-actions class="import-translations-dialog__actions">
  <eiq-button [text]="'Cancel'" [style]="'stroked'" [color]="'light'" testId="import-translations-dialog-cancel" (clicked)="onCancel()"></eiq-button>
  <eiq-button [text]="'Import'" [color]="'primary'" testId="import-translations-dialog-import" [disabled]="!canImport$()" (clicked)="onImport()"></eiq-button>
</div>
